import React from 'react';
import styled from 'styled-components';
import Break from 'components/Break';
import ControlTypeForm from 'components/ControlTypeForm';
import { pullAll } from 'lodash';
import { NO_PARENT_OPTION_VALUE, CONTROL_TYPES } from 'utils/appConstants';
import { ReactComponent as RemoveIcon } from '../assets/remove-icon.svg';

const ControlTypeWrapper = styled.div`
  width: 100%;
  box-sizing: border-box;
  box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.12);
  border-radius: 2px;
  padding: 10px;
  margin: 8px 0;
`;

const ControlTypeHeader = styled.div`
  height: 40px;
  width: 100%;
  display: flex;
  align-items: center;
`;

const ControlTypeNumber = styled.p`
  font-size: 12px;
  margin-right: 8px;
`;

const Dropdown = styled.select`
  border: ${({ isError }) =>
    isError ? '1px solid #EA6E6D' : '1px solid #e5e7eb'};
  background-color: #ffffff;
  border-radius: 2px;
  width: 66%;
  height: 24px;
  padding: 4px 8px;
  font-size: 12px;
`;

const RemoveControlTypeButton = styled.button`
  margin: 0 8px 0 auto;
  background: none;

  :hover {
    cursor: pointer;
  }
`;

const ControlType = ({
  handleFormChange,
  removeControlType,
  index,
  handleControlTypeSelect,
  controlObj,
  takenControls,
  removeCurve,
  isError,
  setWaitingForReturn
}) => {
  const selectOption = [];
  for (let key of Object.keys(CONTROL_TYPES)) {
    if (!takenControls.includes(key) || key === controlObj.controlType) {
      selectOption.push(
        <option key={key} value={key}>
          {CONTROL_TYPES[key].name}
        </option>
      );
    }
  }

  return (
    <ControlTypeWrapper>
      <ControlTypeHeader>
        <ControlTypeNumber>{index + 1}.</ControlTypeNumber>
        <Dropdown
          value={controlObj.controlType}
          name="controlType"
          onChange={e => handleControlTypeSelect(e, index)}
          isError={isError}
        >
          <option key="noParentOption" value={NO_PARENT_OPTION_VALUE}>
            Select a Control Mode
          </option>
          {selectOption}
        </Dropdown>
        <RemoveControlTypeButton
          type="button"
          onClick={e => removeControlType(index)}
        >
          <RemoveIcon fill="#0779af" width="17" height="17" />
        </RemoveControlTypeButton>
      </ControlTypeHeader>
      <Break margin="6px 0" />
      <ControlTypeForm
        controlType={controlObj.controlType}
        handleFormChange={handleFormChange}
        index={index}
        controlObj={{ ...controlObj }}
        removeCurve={removeCurve}
        isError={isError}
        setWaitingForReturn={setWaitingForReturn}
      />
    </ControlTypeWrapper>
  );
};

export default ControlType;
